<template>
   <div>
      <b-skeleton v-if="loading" animation="fade" height="240px" width="100%"></b-skeleton>
      <b-container v-if="loading" class="mb-5 no-search-results-wrap">
         <!-- Skeleton -->
         <b-row>
            <b-col cols="12" sm="6" lg="4" xl="4" class="mb-4 p-4" v-for="n in 6" :key="n">
               <b-card no-body img-top>
                  <b-skeleton-img card-img="top" aspect="2:1">{{ n }}</b-skeleton-img>
                  <b-card-body>
                     <b-skeleton animation="fade" width="85%"></b-skeleton>
                     <b-skeleton animation="fade" width="55%"></b-skeleton>
                     <b-skeleton animation="fade" width="70%"></b-skeleton>
                  </b-card-body>
               </b-card>
            </b-col>
         </b-row>
      </b-container>

      <div
         v-if="!this.loading && this.bikeUser && this.bikeUser.user"
         class="d-flex flex-column justify-content-center text-center mb-4"
         style="background: #1f443d;
          min-height: 240px; padding: 30px 10px;"
      >
         <div v-if="this.bikeUser.user.avatar">
            <el-image
               @click="fixRelativeBody()"
               style="width: 70px; height: 70px;"
               class="mb-2 rounded ml-auto mr-auto mt-0"
               :src="getCover(this.bikeUser.user.avatar)"
               fit="cover"/>
         </div>

         <h1 class="text-center text-white w-100 h4" style="align-self: center;">
            {{this.bikeUser.user.additionalInformation.businessName
            || this.bikeUser.user.firstName + ' ' + this.bikeUser.user.lastName}}
            <small style="font-size: 1rem"> | {{this.bikeUser.user.address.city}}, {{this.bikeUser.user.address.state}}</small>
         </h1>

         <b-container class="">
            <b-row>
               <b-col cols="12">
                  <p
                     class="text-white w-75 mr-auto ml-auto"
                     style="opacity: 0.8">
                        {{this.bikeUser.user.description
                        && this.bikeUser.user.description.length > 199
                        && !readMore
                        ? this.bikeUser.user.description.substring(0,200) + '...'
                        :  this.bikeUser.user.description}}
                  </p>
                  <el-button
                     v-if="this.bikeUser.user.description
                           && this.bikeUser.user.description.length > 199"
                     class="bg-transparent pt-1 pb-1"
                     size="small"
                     round
                     type="info"
                     @click="handleReadMore()"
                  >
                     {{readMore ? 'Recolher' : 'Ler mais'}}
                  </el-button>
               </b-col>
            </b-row>
         </b-container>
         <el-input class="bike-search-input" type="text" v-model="searchQuery" placeholder="Buscar bicicleta"></el-input>
      </div>

      <b-container v-if="!loading && filteredBikes.length">
         <!-- Card Bicicleta -->
         <b-row class="position-relative" style="z-index: 1">
            <b-col sm="6" lg="4" xl="3">
               <UserVerificationCard
                  :userId="this.$route.params.slug"
               />
            </b-col>
            <b-col sm="6" lg="8" xl="9">
               <b-row class="position-relative" style="z-index: 1">
                  <!-- eslint-disable -->
                  <b-col
                     v-if="(!currentUser && bike.status === 2
               || bike.status === 3)
               || (currentUser && currentUser.user._id === bike.user._id && bike.status !== 0)
               || (currentUser && currentUser.user._id !== bike.user._id && bike.status === 2
               || bike.status === 3)"
                     sm="12"
                     lg="6"
                     xl="6"
                     class="mb-4"
                     v-for="(bike, index) in filteredBikes"
                     :key="index">
                     <b-badge v-if="bike.status === 1 || false" class="review status-indicator">
                        Em análise - Não visível</b-badge>
                     <b-badge v-if="bike.status === 4 || false" class="disapprove status-indicator">
                        Reprovada - Não visível</b-badge>
                     <CardBike v-if="bike._id"  :loading="loading"  :bike="bike" :showFooter="false"/>
                  </b-col>
               </b-row>
            </b-col >
         </b-row>
      </b-container>
   </div>

</template>

<script>
import businessMark from "@/assets/img/business-mark.png";
import CardBike from "@/components/CardBike";
import BikeImg from '@/helpers/GetBikeCover';
import { BBadge, BCard, BCardBody, BSkeleton, BSkeletonImg } from "bootstrap-vue";
import Advertiser from '../../services/advertiser';
import UserVerificationCard from "@/components/UserVerificationCardV2";
export default {
   name: 'advertiser',
   components: {
      CardBike,
      BCard,
      BCardBody,
      BBadge,
      BSkeleton,
      BSkeletonImg,
      UserVerificationCard
   },
   directives: {
      'b-card': BCard,
      'b-card-body': BCardBody,
      'b-badge': BBadge,
      'b-skeleton': BSkeleton,
      'b-skeleton-img': BSkeletonImg
   },
   data() {
      return {
         loading: true,
         bikes: [],
         readMore: false,
         businessMark,
         searchQuery: '',
      }
   },
   mounted() {
      this.showBikes(this.$route.params.slug)
   },
   updated() {
   },
   methods: {
      showBikes(id) {
         Advertiser.showBikes(id)
            .then(
               response => {
                  this.bikes = response.data.data;
                  this.loading = false
               }
            )
            .catch(err => {
               this.$message.error(err.response.data.message);
               this.loading = false
               this.$loading().close()
            })
            .finally(() => {
               this.loading = false
            })
      },

      getCover(uri) {
         return BikeImg.getCover(uri);
      },
      fixRelativeBody() {
         let body = document.querySelector("body");
         body.style.overflow = 'visible';
      },
      handleReadMore() {
         this.readMore = !this.readMore
      },
   },
   computed: {
      currentUser() {
         return this.$store.state.auth.user;
      },
      bikeUser() {
         if (this.bikes.length) {
            return this.bikes[0]
         }
         return null
      },
      filteredBikes() {
        if (!this.searchQuery) {
            return this.bikes;
        }

        const searchQueryLower = this.searchQuery.toLowerCase();

        return this.bikes.filter(bike => {
            const bikeTextToSearch = bike.address.name + bike.name;
            return bikeTextToSearch.toLowerCase().includes(searchQueryLower);
        });
    },
   }
}
</script>
<style lang="scss">
   .status-indicator {
      position: absolute;
      top: 14px;
      width: 80%;
      z-index: 2;
      padding: 7px;
      margin: auto;
      left: 0;
      right: 0;
      &.review {
         background: #e4a425;
         color: #fff !important;
      }
      &.rented {
         background: #409eff;
         color: #fff !important;
      }
      &.disapprove {
         background: #e41f00;
         color: #fff !important;
      }
   }

   .bike-search-input {
        width: 90%;
        max-width: 380px;
        margin: 0 auto;
    }

   .user-verification-card {
      margin-top: 0 !important;
   }

</style>
